import { Theme, alpha } from '@mui/material';

export const getListItemStyles = (theme: Theme) => ({
  py: 2,
  px: 3,
  borderRadius: 1,
  bgcolor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : alpha(theme.palette.action.hover, 0.03),
  border: `1px solid ${
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.1)'
      : alpha(theme.palette.divider, 0.5)
  }`,
  mb: 2,
  width: '100%',
});

export const getAccordionStyles = (theme: Theme) => ({
  width: '100%',
  mt: 2,
  mb: 2,
  backgroundColor: 'rgba(0, 0, 0, 0.01)',
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: 'none',
  borderRadius: 4,
  overflow: 'hidden',

  '&:first-of-type': {
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  '&:last-of-type': {
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
  },
});

export const getAccordionSummaryStyles = (theme: Theme) => ({
  '&:hover': {
    bgcolor: alpha(theme.palette.primary.main, 0.6),
  },
  minHeight: 64,
  transition: 'background-color 0.2s',
});

export const accordionDetailsStyles = {
  p: 3,
};

export const textFieldStyles = {
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
  },
};

export const errorTextStyles = {
  mt: 1,
  color: 'error.main',
  fontWeight: 'medium',
};
